import * as React from 'react'
import Cursor from './Cursor'
import safeParse from '~/lib/safeParse'

export default function TypingEffect({
  message,
  baseSpeed,
  aiStreamComplete,
  setTypingComplete,
  displayedText,
  setDisplayedText,
  index,
  setIndex,
}) {
  React.useEffect(() => {
    const getSpeed = (char) => {
      if (char === '.' || char === '!' || char === ',') {
        return baseSpeed
      } else if (char === ' ') {
        return baseSpeed
      } else {
        return baseSpeed
      }
    }

    if (index < message.length) {
      setTypingComplete(false)
      const currentChar = message.charAt(index)
      const timeoutId = setTimeout(() => {
        setDisplayedText((prev) => prev + currentChar)
        setIndex(index + 1)
      }, getSpeed(currentChar))

      return () => clearTimeout(timeoutId)
    } else {
      // Wait 1 second before setting typingComplete to true
      const timeoutId = setTimeout(() => {
        if (index >= message.length) {
          setTypingComplete(true)
        }
      }, 1000)

      return () => clearTimeout(timeoutId)
    }
  }, [
    displayedText,
    message,
    index,
    baseSpeed,
    setTypingComplete,
    setDisplayedText,
    setIndex,
  ])

  const paragraphs = displayedText.split('\n\n')

  const showCursor = (paragraphIndex) => {
    if (aiStreamComplete) return false

    return paragraphIndex === paragraphs.length - 1
  }

  return (
    <>
      {paragraphs.map((paragraph, index) => (
        <p key={index} className="m-4">
          {safeParse(paragraph)}
          <Cursor show={showCursor(index)} />
        </p>
      ))}
      <Cursor show={showCursor(-1)} />
    </>
  )
}
